<div class="container">
    <br>
    <div class="row">
        <div class="col-sm-7 col-12 title-trends">Tendencias territoriales</div>
        <div class="col-sm-5 col-12">
            <div class="row justify-content-end">
                <a class="col-3" routerLink="../tendencia-global">
                    <img class="icon-trends" src="assets/img/t/tg-w.webp" alt="Tendencia global"></a>
                <a class="col-3" routerLink="../tendencia-nacional">
                    <img class="icon-trends" src="assets/img/t/tn-w.webp" alt="Tendencia nacional"></a>
                <a class="col-3" routerLink="../tendencia-territorial">
                    <img class="icon-trends" src="assets/img/t/tt-b.webp" alt="Tendencia territorial"></a>
                <a class="col-3" routerLink="../tendencia-sectorial">
                    <img class="icon-trends" src="assets/img/t/ts-w.webp" alt="Tendencia sectorial"></a>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <p class="col-12">Fenómeno que tiene lugar al interior del país, en o entre las regiones, el cual es consistente
            en el tiempo. Su configuración incide en el desarrollo territorial y nacional actual y en el mediano o largo
            plazo. </p>
    </div>
    <!-- Start carousel -->
    <app-carousel [idTier1ForSlider]="idTier1"></app-carousel>
    <!-- End carousel -->
    <div class="row">
        <div class="col-md-12">
            <p class="py-4">Seleccione un territorio para explorar sus principales tendencias territoriales:</p>
        </div>
        <div class="col-12 col-sm-4 col-md-4 mt-2">
            <div class="map-ut"></div>
        </div>
        <ng-container *ngIf="t3Selected.length>0">
            <div class="col-12 col-sm-8 col-md-8">
                <div class="dpto-title">
                    <li>{{dptoNameSelected}}</li>
                </div>

                <div class="row btn-trend-m">
                    <div class="col-6 col-sm-4 col-md-3 col-elements" *ngFor="let p of t3Selected">
                        <div class="card-elements" routerLink="../ficha/{{p.code}}">
                            <div class="btn-trends">
                                <i class="fa fa-location-arrow" aria-hidden="true"></i>
                                <div class="box-text-btn">{{p.shorttitle}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="fichaGeo.length > 0; else noDocumentsMessage">
                    <hr>
                    <p *ngFor="let f of fichaGeo">Descargue el reporte completo
                        <a *ngIf="f.url.startsWith('http')" class="underline" href="{{f.url}}" target="_blank">aquí.</a>
                        <a *ngIf="f.url.startsWith('/uploads')" class="underline" href="{{URLObs}}{{f.url}}" target="_blank">aquí.</a>
                    </p>
                </ng-container>
                <ng-template #noDocumentsMessage>
                    <hr>
                    <p>Pronto se subirá este reporte territorial.</p>
                </ng-template>
            </div>
        </ng-container>
    </div>

</div>
